module.exports = __webpack_public_path__ + "img/Feature.d56f6b79.jpg";